import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_back_top = _resolveComponent("n-back-top")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_n_message_provider = _resolveComponent("n-message-provider")!
  const _component_n_global_style = _resolveComponent("n-global-style")!
  const _component_n_config_provider = _resolveComponent("n-config-provider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_back_top, { right: 100 }),
    _createVNode(_component_n_config_provider, { "theme-overrides": _ctx.themeOverrides }, {
      default: _withCtx(() => [
        _createVNode(_component_n_message_provider, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }),
        _createVNode(_component_n_global_style)
      ]),
      _: 1
    }, 8, ["theme-overrides"])
  ], 64))
}